import { useMemo } from 'react';

import EventInfoRow from './event-info-row';

import { ORDER_OUTCOME, SIZE_DECIMALS } from '@/constants/solana';
import { useAvgBuyPrice } from '@/hooks/backend/metrics/use-avg-buy-price';

type Props = {
  price: string;
  shares: string;
  id: number;
  averageOrderPrice: number;
  outcome: ORDER_OUTCOME;
};

const EventSellProfitRow = ({
  price,
  shares,
  id,
  outcome,
  averageOrderPrice,
}: Props) => {
  const { data: buyPriceRes } = useAvgBuyPrice(
    Number(id),
    outcome === ORDER_OUTCOME.YES ? 'YES' : 'NO',
  );

  const avgBuyPrice = useMemo(() => {
    if (!buyPriceRes) return 0;
    return buyPriceRes.averageBuyPrice;
  }, [buyPriceRes]);

  const profit = useMemo(() => {
    if (!price || !shares || !avgBuyPrice) return 0;

    const avgSellPrice = averageOrderPrice || +price;

    return ((+avgSellPrice - avgBuyPrice) * +shares) / SIZE_DECIMALS;
  }, [price, shares, avgBuyPrice, averageOrderPrice]);

  return (
    <EventInfoRow
      title="Profit"
      usdc
      className="text-primary-cta text-[18px] font-medium"
      content={
        <p>
          {parseFloat(profit.toFixed(2)) >= 0 ? '+' : ''}
          {profit.toFixed(2)}
        </p>
      }
    />
  );
};

export default EventSellProfitRow;
